import { render, staticRenderFns } from "./SignInDropdown.vue?vue&type=template&id=3d22ae18"
import script from "./SignInDropdown.vue?vue&type=script&lang=js"
export * from "./SignInDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotDropdown: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/Dropdown/Dropdown.vue').default})
